export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
}

export function scheduleNotification(title: string, body: string, timestamp: number, tag: string) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SCHEDULE_NOTIFICATION',
      title,
      body,
      timestamp,
      tag
    });
  }
}

export function showNotification(title: string, body: string, tag: string) {
  console.log(`📢 showNotification called: ${title}, tag: ${tag}`);
  console.log(`Notification permission: ${Notification.permission}`);

  if (!('Notification' in window)) {
    console.error('❌ Notifications not supported');
    return;
  }

  if (Notification.permission !== 'granted') {
    console.error('❌ Notification permission not granted');
    return;
  }

  if ('serviceWorker' in navigator && 'Notification' in window && Notification.permission === 'granted') {
    navigator.serviceWorker.ready.then((registration) => {
      console.log('✅ Service worker ready, showing notification');
      registration.showNotification(title, {
        body: body,
        icon: '/icon-192.png',
        badge: '/icon-192.png',
        vibrate: [200, 100, 200, 100, 200],
        tag: tag,
        requireInteraction: true,
        silent: false,
        timestamp: Date.now()
      }).then(() => {
        console.log('✅ Notification shown successfully');
      }).catch((err) => {
        console.error('❌ Failed to show notification:', err);
      });
    }).catch((err) => {
      console.error('❌ Service worker not ready:', err);
    });
  }
}

export function scheduleAllPrayerNotifications(prayers: Array<{key: string, name: string, time: string}>) {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  prayers.forEach(prayer => {
    if (prayer.key === 'sunrise') return;
    if (!prayer.time) return;

    const [hours, minutes] = prayer.time.split(':').map(Number);
    const prayerMinutes = hours * 60 + minutes;

    // Schedule 20 min before
    const notify20 = prayerMinutes - 20;
    if (notify20 > currentMinutes) {
      const timestamp20 = new Date(now);
      timestamp20.setHours(Math.floor(notify20 / 60), notify20 % 60, 0, 0);
      scheduleNotification(
        `${prayer.name} in 20 minutes`,
        `Prayer time approaching`,
        timestamp20.getTime(),
        `${prayer.key}-20`
      );
    }

    // Schedule 10 min before
    const notify10 = prayerMinutes - 10;
    if (notify10 > currentMinutes) {
      const timestamp10 = new Date(now);
      timestamp10.setHours(Math.floor(notify10 / 60), notify10 % 60, 0, 0);
      scheduleNotification(
        `${prayer.name} in 10 minutes`,
        `Prayer time approaching`,
        timestamp10.getTime(),
        `${prayer.key}-10`
      );
    }

    // Schedule exact time
    if (prayerMinutes > currentMinutes) {
      const timestampExact = new Date(now);
      timestampExact.setHours(hours, minutes, 0, 0);
      scheduleNotification(
        `${prayer.name} Time`,
        `It's time for ${prayer.name}`,
        timestampExact.getTime(),
        `${prayer.key}-exact`
      );
    }
  });
}
